import {Component} from '@angular/core';
import {BaseComponent} from "../common/base-component";

@Component({
    selector: 'dk-bank-accounts',
    template: require('./bank-accounts.html')
})

export class BankAccountsComponent extends BaseComponent {
    constructor() {
        super();
    }
}
